import { clientFetch } from '@medifind/interface';

export const validateYoutubeVideoID = (youtubeVideoID) => {
  return clientFetch(`/validate/youtube`, {
    params: { youtubeVideoID },
  });
};
